module.exports = __webpack_public_path__ + "media/images/athletes/3592-382670ee8ffa2b50aaaf9822ce448895.png";